import "./home.css";

import React from "react";

import { SEASONS } from "../../data/seasons";
import Hero from "./Hero";
import Intro from "./Intro";
import Season from "./Season";
import Footer from "../layout/Footer";

const Home = () => {
  return (
    <React.Fragment>
      <main>
        <Hero />
        <Intro />
        {SEASONS.map((season) => (
          <Season
            key={season.id}
            season={season}
          />
        ))}
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default Home;
